import { IconArrowRotateRightLeft } from '@sequencehq/core-components'
import { FC } from 'react'
import styled, { css, keyframes } from 'styled-components'

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const SpinningIcon = styled.span<{ $isSpinning: boolean }>`
  display: inline-flex;
  animation: ${props =>
    props.$isSpinning
      ? css`
          ${spin} 1s linear infinite
        `
      : 'none'};
`

export const RefreshAccountsIcon: FC<{
  isRefreshing: boolean
  color?: string
}> = ({ isRefreshing, color }) => (
  <SpinningIcon $isSpinning={isRefreshing}>
    <IconArrowRotateRightLeft color={color} />
  </SpinningIcon>
)
